import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CaseManagementService } from '../../../services/caseManagement.service';
import { WorkorderService } from '../../../services/workorder.service';
import { forkJoin } from 'rxjs';
import { AddAttachmentComponent } from '../add-attachment/add-attachment.component';

@Component({
  selector: 'view-attachment',
  templateUrl: './view-attachment.component.html',
  styleUrls: ['./view-attachment.component.scss']
})
export class ViewAttachmentComponent implements OnInit {
  loading: boolean;
  Attachments: any = [];
  workOrderKey: Number;
  emailFaxData: any;
  vendorInvoices: any;
  showInvoiceTab: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ViewAttachmentComponent>,
    public workOrderService: WorkorderService,
    public caseManagementService: CaseManagementService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.workOrderKey = this.caseManagementService.getWorkOrderKey()
    this.showInvoiceTab = parseInt(JSON.parse(sessionStorage.getItem('userDetails')).viewProviderInvoice) == 1 ? true : false;
    this.getAllAttachments();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getAllAttachments() {
    this.Attachments = [];
    this.emailFaxData = [];
    this.vendorInvoices = [];
    let requests = []
    this.loading = true;
    requests.push(this.caseManagementService.getWorkOrderAttachment(this.workOrderKey));
    requests.push(this.caseManagementService.getEmailAndFaxHistory(this.workOrderKey));
    if (this.showInvoiceTab) {
      requests.push(this.caseManagementService.getVendorInvoices(this.workOrderKey));
    }
    forkJoin([...requests]).subscribe((response: any) => {
      this.loading = false;
      const attResult = response[0] || [];
      this.emailFaxData = response[1] || [];
      if (this.showInvoiceTab) {
        this.vendorInvoices = response[2] || [];
        this.Attachments = attResult;
      } else {
        attResult.forEach(element => {
          if (element.purpose !== 943) {
            this.Attachments.push(element);
          }
        });
      }
    }, (error) => {
      this.loading = false;
      console.error('ViewAttachmentComponent_getAllAttachments', error);
    });
  }

  goToLink(link) {
    window.open(link, "_blank");
  }

  addAttachment() {
    let dialogRef = this.dialog.open(AddAttachmentComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      width: '45%',
      data: this.workOrderKey
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllAttachments();
      }
    });
  }
}
